//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import {
  // events,
  RunConfigService,
  util,
  StringService,
  MarketSiteRegions,
  SitesLocalStorageService,
  SitesSessionStorageService
} from "@nuskin/ns-util";
import { TopNavService } from "@nuskin/ns-product";
import { NsIcon, NsAnimateHeight } from "@nuskin/design-components";
import { isString } from "@nuskin/ns-common-lib";

import NsDynamicHtml from "./NsDynamicHtml.vue";
import NsHeaderLoyaltyRewards from "./NsHeaderLoyaltyRewards.vue";
import NsFooterNav from "./NsFooterNav.vue";
import vueEventBus from "./EventBus";

const AUTO_REDIRECT_KEY = "autoRedirectGlobalLanding";
const CURRENT_PAGE_KEY = "currentPage";
const REGIONS_ALLOWED_KEY = "regionsAllowed";
const HREF_OVERRIDE_KEY = "hrefOverride";

const TOPNAV_PRODUCT_LINE = "nsTopnavProductLine";
const TOPNAV_LIST_OF_LINKS = "nsNavListOfLinks";
const TOPNAV_PRODUCT_HIGHLIGHT = "nsTopnavProductHighlight";
const TOPNAV_GIVING_BACK = "nsTopnavGivingBack";
const TOPNAV_CONTENT_TYPES = [
  TOPNAV_PRODUCT_LINE,
  TOPNAV_LIST_OF_LINKS,
  TOPNAV_PRODUCT_HIGHLIGHT,
  TOPNAV_GIVING_BACK
];
const SUBNAV_HIDDEN_CONTENT_TYPES = [TOPNAV_PRODUCT_LINE, TOPNAV_GIVING_BACK];

export default {
  name: "NsHeaderDrawer",
  components: {
    NsIcon,
    NsDynamicHtml,
    NsAnimateHeight,
    NsHeaderLoyaltyRewards,
    NsFooterNav
  },
  props: {
    /**
     * Navigation for the footer
     */
    footerNavigation: {
      type: Array,
      default: () => []
    },
    /**
     * Hide Footer Nav
     */
    hideFooterNav: Boolean,
    /**
     * Hide sign up text and link in Footer
     */
    hideFooterSignup: Boolean,
    /**
     * Hides join us
     */
    hideJoinUs: Boolean,
    /**
     * Hides legal links
     */
    hideLegalLinks: Boolean,
    /**
     * Hides loyalty
     */
    hideLoyalty: Boolean,
    /**
     * Hides region selector
     */
    hideRegionSelector: Boolean,
    /**
     * Hides the top navigation
     */
    hideTopNav: Boolean,
    /**
     * Allows you to set where the "select other region" redirects too
     */
    regionSelectorPath: {
      type: String,
      default: "/content/nuskin.html#region-selection"
    },
    /**
     * Home url
     */
    homeUrl: {
      type: String,
      default: ""
    },
    /**
     * If set, this will override the page redirect on the region selector page
     */
    hrefOverride: {
      type: String,
      default: ""
    },
    /**
     * Join us label and link
     */
    joinUs: {
      type: Object,
      default: () => ({
        label: "",
        link: ""
      })
    },
    /**
     * Array of links to display in the top utility bar: left
     * Objects in array require 'href' and 'name'
     */
    legalLinks: {
      type: Array,
      default: () => []
    },
    /**
     * Main navigation. Default is null in order to load by service if nothing
     * is passed from parent
     */
    navigation: {
      type: Array,
      default: null
    },
    /**
     * The region
     */
    region: {
      type: Object,
      default: null
    },
    /**
     * If set, this will only show regions according to what is in the array
     * [ "en_US", "es_US" ]
     */
    regionsAllowed: {
      type: Array,
      default: () => []
    },
    /**
     * Signup url
     */
    signupHref: {
      type: String,
      default: ""
    },
    /**
     * Translations
     */
    translations: {
      type: Object,
      default: () => ({
        selectOther: "Select Another Region",
        sendSignupInvite: "Join Nu Skin",
        home: "Home",
        enjoyLoyalty: "Earn nJoy Rewards"
      })
    }
  },
  data() {
    return {
      activeNavigationCustomComponent: "",
      allCategoryText: "",
      currentPage: "",
      navigationFromService: [],
      navigationStack: [],
      regionFromService: {},
      regionSelectorOpen: false
    };
  },
  computed: {
    runConfig() {
      return this.$NsAppService.runConfig || {};
    },
    activeCategoryLinkText() {
      if (this.showMainNavigation) {
        return "";
      }
      return this.allCategoryText.replace(
        "%categoryName%",
        this.activeNavigation.title || this.activeNavigation.name
      );
    },
    activeNavigation() {
      const activeNavigation = { subnav: this.localNavigation };
      if (this.showMainNavigation) {
        return activeNavigation;
      } else {
        return this.getActiveNavigation(activeNavigation);
      }
    },
    // limit links to 3;
    limitedLegalLinks() {
      return (
        this.legalLinks && this.legalLinks.filter(link => link.name).slice(0, 3)
      );
    },
    localHomeUrl() {
      return this.hrefOverride
        ? this.hrefOverride
        : this.homeUrl || util.getLocaleUrl() + "home.html";
    },
    localNavigation() {
      return this.navigation || this.navigationFromService;
    },
    localRegion() {
      return this.region || this.regionFromService;
    },
    regionDisplay() {
      return this.getRegionDisplay(this.localRegion);
    },
    showFooterNav() {
      return (
        this.showMainNavigation &&
        !this.hideFooterNav &&
        !!this.footerNavigation &&
        this.footerNavigation.length > 0
      );
    },
    showMainNavigation() {
      return this.navigationStack.length === 0;
    },
    showSubNavigation() {
      return (
        !this.hideTopNav &&
        (!this.activeNavigation.navContentType ||
          !SUBNAV_HIDDEN_CONTENT_TYPES.includes(
            this.activeNavigation.navContentType
          ))
      );
    },
    showSeeAllLink() {
      let topNav = null;
      if (this.navigationStack && this.navigationStack.length === 2) {
        topNav = this.localNavigation[this.navigationStack[0]];
      }
      return (
        !this.showMainNavigation &&
        !!topNav &&
        this.hasTopnavComponent(topNav) &&
        !topNav.hideSeeAll
      );
    }
  },
  mounted() {
    this.currentPage = window.location.pathname;
    this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    init() {
      this.setCommonStrings();

      // Get and set navigation from service if not passed from parent
      if (!this.navigation) {
        this.setNavigationFromService();
      }

      // Get and set regions from service if not passed from parent.
      if (!this.region) {
        this.setRegionFromService();
      }
    },

    /**
     * See if the string is a JSON string.
     */
    fromJsonString(string, defaultValue = undefined) {
      try {
        return JSON.parse(string);
      } catch (error) {
        return string || defaultValue;
      }
    },

    async setNavigationFromService() {
      const data = await TopNavService.getTopNavigation();
      this.navigationFromService = data;
    },

    async setRegionFromService() {
      const data = await MarketSiteRegions.getMarketSiteRegionByCountry(
        this.runConfig.country
      );

      this.regionFromService =
        data.countryname.find(
          co => co.countryCode === this.runConfig.country
        ) ||
        // else find default
        data.countryname.find(co => co.countryCode === "US");
    },

    async setCommonStrings() {
      const commonStrings = [
        { key: "allCategoryText", dflt: "See all %categoryName%" }
      ];

      const { allCategoryText } = await StringService.getStrings(commonStrings);

      this.allCategoryText = allCategoryText;
    },

    getRegionDisplay(region) {
      const currLanguageCode = RunConfigService.getRunConfig().language;

      let language = "";
      let countryName = "";
      let otherLanguages = [];

      // Get the current language
      if (region.languageCodes) {
        const languageIndex = region.languageCodes.findIndex(
          code => code === currLanguageCode
        );
        language = (region.languages || [])[languageIndex];
      }

      // Get the current country in local language
      if (region.locale_names) {
        countryName = region.locale_names.find(
          loc => Object.keys(loc)[0] === currLanguageCode
        )[currLanguageCode];
      }

      // Get "other languages" for dropdown. ({language, path, active, show})
      if (region.languages) {
        otherLanguages = region.languageCodes.map((languageCode, index) => {
          const language = region.languages[index];
          const path = region.paths.find(
            item => Object.keys(item)[0] === languageCode
          )[languageCode];

          return {
            language,
            path: this.getPathFromLocale(path),
            active: languageCode === currLanguageCode,
            show: this.regionsAllowed.length
              ? this.regionsAllowed.includes(
                  languageCode + "_" + region.countryCode
                )
              : true
          };
        });
      }

      return {
        countryCode: region.countryCode,
        countryName,
        language,
        otherLanguages: otherLanguages.filter(lang => lang.show)
      };
    },

    getPathFromLocale(localePath) {
      const currentURL = window.location.pathname;
      const fullPath =
        localePath +
        "/" +
        currentURL.substr(util.getLocaleUrl().length, currentURL.length);
      return fullPath;
    },

    hasTopnavComponent(navItem) {
      return (
        !!navItem.navContentType &&
        TOPNAV_CONTENT_TYPES.includes(navItem.navContentType)
      );
    },

    allowSubNavigation(navItem) {
      return (
        (navItem.subnav && navItem.subnav.length > 0) ||
        this.hasTopnavComponent(navItem)
      );
    },

    selectSubNavigation(navIndex) {
      this.navigationStack.push(navIndex);
      this.setActiveNavigationCustomComponent();
    },

    handleBackNavigation() {
      this.navigationStack.pop();
      this.setActiveNavigationCustomComponent();
    },

    resetNavigation() {
      this.navigationStack = [];
      this.activeNavigationCustomComponent = "";
    },

    toggleRegionDropdown() {
      this.regionSelectorOpen = !this.regionSelectorOpen;
    },

    selectOtherRegion() {
      if (this.regionsAllowed && this.regionsAllowed.length) {
        SitesSessionStorageService.writeItem(
          REGIONS_ALLOWED_KEY,
          JSON.stringify(this.regionsAllowed)
        );
      }

      if (this.hrefOverride) {
        SitesSessionStorageService.writeItem(
          HREF_OVERRIDE_KEY,
          isString(this.hrefOverride)
            ? this.hrefOverride
            : JSON.stringify(this.localHomeUrl)
        );
      }

      SitesLocalStorageService.writeItem(
        CURRENT_PAGE_KEY,
        window.location.href
      );

      SitesLocalStorageService.removeItem(AUTO_REDIRECT_KEY);

      window.location = this.regionSelectorPath;
    },

    getActiveNavigation(navItem, stackIndex = 0) {
      const navIndex = this.navigationStack[stackIndex];
      if (navIndex >= 0) {
        const subnavItem = navItem.subnav[navIndex];
        if (subnavItem) {
          const active = this.getActiveNavigation(subnavItem, stackIndex + 1);
          if (navItem.hideSeeAll) {
            active.hideSeeAll = navItem.hideSeeAll;
          }
          return active;
        }
      }
      return navItem;
    },

    setActiveNavigationCustomComponent() {
      this.activeNavigationCustomComponent = "";
      if (
        this.hasTopnavComponent(this.activeNavigation) &&
        this.activeNavigation.navContentUrl
      ) {
        const _this = this;
        axios
          .get(this.activeNavigation.navContentUrl)
          .then(function(response) {
            _this.activeNavigationCustomComponent = response.data.trim();
          })
          .catch(function(error) {
            console.error("Failed to get Custom Navigation content.", error);
          });
      }
    },

    handleCloseClick() {
      this.resetNavigation();
      this.$emit("close-drawer");
    },

    handleFooterSignupClick() {
      window.location.href = this.signupHref;
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      // watch app service to finish loading
      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.init,
        {
          immediate: true
        }
      );

      // listen to config changes
      vueEventBus.$on("config-changed", this.init);
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to event bus
      vueEventBus.$off();
    }
  }
};
